import React from 'react';
import { LINKED_ACCOUNTS_COLORS } from '@/constants/residents/mobile/linkedAccountsColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { linkedAccountsStrings } from '@/constants/residents/strings';
import { MobileEmptyState } from './MobileEmptyState';

const ConnectionIcon = RESIDENTS_SVG_COMPONENTS.CONNECTION;

/**
 * Mobile Empty State for Linked Accounts
 * Dark theme empty state matching Figma design
 */
export const MobileLinkedAccountsEmpty: React.FC = () => {
  return (
    <MobileEmptyState
      icon={<ConnectionIcon width={68} height={68} color={LINKED_ACCOUNTS_COLORS.textMuted} />}
      title={linkedAccountsStrings.empty.title}
      description={linkedAccountsStrings.empty.description}
    />
  );
};
